






























import {Component, Prop, Vue} from 'vue-property-decorator'
import {$, ID, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import AuditoriaMotivo from '@/model/resource/AuditoriaMotivo'

const metaInfo = () => ({
  title: $.t('view.persist.userPersist.title'),
})

@Component({
  metaInfo,
})
export default class AuditReasonPersistView extends Vue {
  @Prop({type: [String, Number]}) id?: ID

  AppConfig = AppConfig

  auditoriaMotivo = new AuditoriaMotivo()

  async mounted() {
    if (this.id) await this.auditoriaMotivo.getAuditoriaMotivo(this.id)
    $.await.done('getAuditoriaMotivo')
  }

  async persist() {
    await this.auditoriaMotivo.persistAuditoriaMotivo()
    successAndPush('system.success.persist', '/manage/audit-reason/list')
  }
}
